import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { FaArrowRight, FaCheck } from 'react-icons/fa';
import { DORES, MAXIMO_DORES } from './dores';
import { mensagemDeErro, onboardingService } from '../../services/onboarding';
import { rastrearTeste } from '../../services/rastreamentoTeste';
import { Botao, GradeDores, OpcaoDor, Rodape, Subtitulo, Titulo } from './styles';

interface Props {
    nomeUsuario: string;
    doresIniciais: string[];
    aoConcluir: (dores: string[]) => void;
}

export default function EtapaDores({ nomeUsuario, doresIniciais, aoConcluir }: Props) {
    const [selecionadas, setSelecionadas] = useState<string[]>(doresIniciais.slice(0, MAXIMO_DORES));
    const [salvando, setSalvando] = useState(false);
    const mexeu = useRef(false);

    // As prioridades salvas podem chegar depois da primeira renderização: enquanto a pessoa não
    // mexeu, a tela acompanha o que veio do servidor.
    useEffect(() => {
        if (!mexeu.current) setSelecionadas(doresIniciais.slice(0, MAXIMO_DORES));
    }, [doresIniciais.join('|')]);

    const alternar = (chave: string) => {
        mexeu.current = true;
        setSelecionadas(atual => {
            if (atual.includes(chave)) return atual.filter(c => c !== chave);
            if (atual.length >= MAXIMO_DORES) return atual;
            return [...atual, chave];
        });
    };

    const continuar = async () => {
        setSalvando(true);
        try {
            await onboardingService.salvarDores(selecionadas);
            rastrearTeste('onboarding_prioridades_escolhidas', { dores: selecionadas });
            aoConcluir(selecionadas);
        } catch (error) {
            toast.error(mensagemDeErro(error, 'Não foi possível salvar suas escolhas.'));
            setSalvando(false);
        }
    };

    const primeiroNome = (nomeUsuario || '').split(' ')[0];

    return (
        <>
            <Titulo>{primeiroNome ? `${primeiroNome}, o que mais pesa hoje na sua locadora?` : 'O que mais pesa hoje na sua locadora?'}</Titulo>
            <Subtitulo>Escolha até {MAXIMO_DORES}. Ao final, levamos você direto para as telas que resolvem cada uma.</Subtitulo>

            <GradeDores>
                {DORES.map(dor => {
                    const selecionado = selecionadas.includes(dor.chave);
                    const bloqueado = !selecionado && selecionadas.length >= MAXIMO_DORES;
                    const Icone = dor.icone;
                    return (
                        <OpcaoDor
                            key={dor.chave}
                            type="button"
                            $selecionado={selecionado}
                            $bloqueado={bloqueado}
                            aria-pressed={selecionado}
                            onClick={() => !bloqueado && alternar(dor.chave)}
                        >
                            <Icone />
                            <span>{dor.titulo}</span>
                            {selecionado && <FaCheck className="check" />}
                        </OpcaoDor>
                    );
                })}
            </GradeDores>

            <Rodape>
                <span>{selecionadas.length} de {MAXIMO_DORES} selecionadas</span>
                <Botao type="button" disabled={selecionadas.length === 0 || salvando} onClick={continuar}>
                    Continuar <FaArrowRight />
                </Botao>
            </Rodape>
        </>
    );
}
